export default __webpack_public_path__ + "static/media/GalanoGrotesque-Heavy.c4da4655.woff";